import { useTranslation } from 'react-i18next';
import { useEffect, useState, useContext, useRef } from 'react';
import { Stepper, Button, TEOLoader } from '@teo/components';
import { useMobile } from '@/util';
import AddUserTeamStep from './Steps/AddUserTeamStep';
import HomePageStep from './Steps/HomePageStep';
import SharingSettingsStep from './Steps/SharingSettingsStep';
import CommunicationStep from './Steps/CommunicationStep';
import { axios } from '@/axios';
import { config } from '@/config';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { Userwithorganisationwithidps } from '@/models';
import { useGet } from '@/query/fetchHooks';
import { initFroala } from '@/components/Froala/froala.js';
import EvaluatorsStep from './Steps/EvaluatorsStep';
import { sortDataLP } from '@/components/LearningPath/util';
import AddFollowersStep from '../AddCourse/Steps/AddFollowersStep';

const steps = ['users', 'homepage', 'share', 'communication'];

const StepsComponentLP = ({
  authUser,
  lpInfo,
  learningpath,
  teamInfo,
  student,
  activeLP,
  activeStep = 1,
  setIsOpenAddContent,
  setActiveLP,
  onSubmit = null,
  setLoader,
  create,
  importProgress = false,
}: any) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(activeStep);
  const [loadStep, setLoadStep] = useState(false);
  const [loadedStep, setLoadedStep] = useState([
    false,
    false,
    false,
    false,
    false,
  ]);
  const isMobile = useMobile();
  const [loadeFroala, setLoadeFroala] = useState(false);
  const [hasCustomLanding, setHasCustomLanding] = useState<boolean>(
    learningpath?.hasCustomLanding === undefined
      ? true
      : learningpath?.hasCustomLanding
  );

  const [lpgroupName, setLpgroupName] = useState<number>(
    learningpath?.lpgroupName || learningpath?.lpName
  );
  const [lpgroupDescription, setLpgroupDescription] = useState(
    learningpath?.lpgroupDescription || learningpath?.lpDescription
  );
  const [lpgroupImage, setlpgroupImage] = useState<string>(
    learningpath?.lpgroupPicture || learningpath?.lpPicture
  );

  const [newTeachers, setNewTeachers] = useState<any[]>([]);
  const [prevTeachers, setPrevTeachers] = useState<any[]>([]);

  const [treeConrent, setTreeConrent] = useState<any[]>([]);

  const handleOpen = async () => {
    await initFroala();
    setTimeout(() => {
      setLoadeFroala(true);
    }, 100);
  };
  useEffect(() => {
    handleOpen();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      document.body.style.overflow = 'hidden';
    }, 0);
  }, []);

  useGet(`/lpteachdetails`, {
    lpgroupId: learningpath?.id,
    organisationId: authUser?.activeOrganisationId,
    onSuccess: (res: any) => {
      if (res?.data) {
        const lpTeachers = res?.data?.map((el: any) => ({
          firstName: el?.firstName,
          lastName: el?.lastName,
          username: el?.username,
          label: el?.username,
          id: el?.userId,
          key: el?.userId,
          userId: el?.userId,
          picture: el?.picture,
        }));
        setNewTeachers(lpTeachers);
        setPrevTeachers(lpTeachers);
      } else {
        setNewTeachers([]);
      }
    },
  });

  useGet(`/learningpathnodedetails`, {
    learningpathId: create ? learningpath?.id : learningpath?.learningpathId,
    organisationId: authUser?.activeOrganisationId,
    onSuccess: async (res: any) => {
      const nodedetails = res?.data?.filter((el: any) => el?.type !== 'root');
      if (nodedetails?.length > 0) {
        const sortData = sortDataLP(nodedetails);
        setTreeConrent(sortData || []);
      }
    },
  });

  //user/teams state
  const [newUsers, setNewUsers] = useState<any[]>([]);
  const [newTeams, setNewTeams] = useState<any[]>([]);

  const userState = {
    newUsers,
    setNewUsers,
    newTeams,
    setNewTeams,
  };

  //homepage state
  const [picture, setPicture] = useState<string>(learningpath?.lpgroupPicture);
  const [abstract, setAbstract] = useState<string>(lpInfo?.abstract);
  const [subTitles, setSubTitles] = useState<string[]>(lpInfo?.subTitles || []);
  const [subImages, setSubImages] = useState<string[]>(lpInfo?.subImages || []);
  const [subTexts, setSubTexts] = useState<string[]>(lpInfo?.subTexts || []);

  const homepageState = {
    hasCustomLanding,
    setHasCustomLanding,
    picture,
    setPicture,
    abstract,
    setAbstract,
    subTitles,
    setSubTitles,
    subImages,
    setSubImages,
    subTexts,
    setSubTexts,
    lpgroupName,
    setLpgroupName,
    setLpgroupDescription,
    lpgroupDescription,
  };

  const [lpStartDate, setLpStartDate] = useState<Date | undefined>(
    learningpath?.lpStartDate || new Date()
  );
  const [emailCertificate, setEmailCertificate] = useState<boolean>(
    learningpath?.emailCertificate || false
  );
  const [lpEndDate, setLpEndDate] = useState<Date | undefined>(
    learningpath?.lpEndDate || null
  );
  const [isMandatory, setIsMandatory] = useState<boolean>(
    learningpath?.isMandatory
  );
  const [lpgroupAccess, setLpgroupAccess] = useState<string>(
    learningpath?.lpgroupAccess || 'private'
  );
  //share state
  const shareState = {
    emailCertificate,
    setEmailCertificate,
    lpgroupAccess,
    setLpgroupAccess,
    lpEndDate,
    setLpEndDate,
    isMandatory,
    setIsMandatory,
    lpStartDate,
    setLpStartDate,
  };

  //commm step state
  const [lvCompletePassed, setLvCompletePassed] = useState<string>(
    lpInfo?.lvCompletePassed || ''
  );
  const [lvCompleteFailed, setLvCompleteFailed] = useState<string>(
    lpInfo?.lvCompleteFailed || ''
  );
  const [lvCustomMail, setLvCustomMail] = useState<string>(
    lpInfo?.lvCustomMail
  );
  const [nrOfReminders, setNrOfReminders] = useState<number>(
    lpInfo?.nrOfReminders || 0
  );
  const [reminderInterval, setReminderInterval] = useState<number>(
    lpInfo?.reminderInterval || 0
  );
  const [doNotRemindProgress, setDoNotRemindProgress] = useState<number>(
    lpInfo?.doNotRemindProgress * 100 || 0
  );
  const [reminderEmail, setReminderEmail] = useState<string>(
    lpInfo?.reminderEmail
  );
  const [welcomeMessage, setWelcomeMessage] = useState<string>(
    lpInfo?.welcomeMessage ||
      t(
        'pages.course_content_flow.step_4.onboarding.message_introduction_onboardin'
      )
  );
  const [onboardingRequired, setOnboardingRequired] = useState<string>(
    lpInfo?.onboardingRequired
  );
  const [onboardingSteps, setOnboardingSteps] = useState<string[]>(
    lpInfo?.onboardingSteps || [
      'onboarding_names_step',
      'onboarding_email_step',
      'onboarding_location_step',
      'onboarding_regime_step',
      'onboarding_referral_step',
      'onboarding_current_work_step',
      'onboarding_contact_step',
      'onboarding_diploma_step',
    ]
  );

  const [specifyItem, setSpecifyItem] = useState(
    learningpath?.specifyEvaluators
  );

  const [contentTeachers, setContentTeachers] = useState<any[]>([]);
  const [evaluatorsStep, setEvaluatorsStep] = useState<any>(false);

  const evaluatorsState = {
    specifyItem,
    setSpecifyItem,
    newTeachers,
    setNewTeachers,
    contentTeachers,
    setContentTeachers,
    setEvaluatorsStep,
  };

  const commState = {
    lvCompletePassed,
    setLvCompletePassed,
    lvCompleteFailed,
    setLvCompleteFailed,
    lvCustomMail,
    setLvCustomMail,
    onboardingRequired,
    setOnboardingRequired,
    onboardingSteps,
    setOnboardingSteps,
    nrOfReminders,
    setNrOfReminders,
    reminderInterval,
    setReminderInterval,
    doNotRemindProgress,
    setDoNotRemindProgress,
    reminderEmail,
    setReminderEmail,
    welcomeMessage,
    setWelcomeMessage,
    learningpath,
  };

  const [currentUsers, setCurrentUsers] = useState([]);
  const [currentTeams, setCurrentTeams] = useState([]);
  const [delUsers, setDelUsers] = useState<any>([]);
  const [delTeams, setDelTeams] = useState<any>([]);

  useGet('/mylpfollows', {
    enabled: !!learningpath?.id,

    userId: authUser?.id,
    organisationId: authUser?.activeOrganisationId,
    lpgroupId: learningpath?.id,
    onSuccess: (result: any) => {
      if (result?.data?.length > 0) {
        setCurrentUsers(result?.data);
      }
    },
    onError: (res: any) => {
      console.error('res', res);
      setCurrentUsers([]);
    },
  });

  useGet('/lpteamdetails', {
    lpgroupId: learningpath?.id,
    organisationId: authUser?.activeOrganisationId,
    onSuccess: (result: any) => {
      if (result?.data?.length > 0) {
        setCurrentTeams(result?.data);
      }
    },
  });

  const handleSave = async () => {
    setLoader(true);

    let result, newLearningPath;

    if (create) {
      //we create new courses based on the last published version, if no published version exist,
      //create one
      // try {
      //   result = await axios.get(
      //     `${config.backend}/learningpath/lastversion/${learningpath?.id}`
      //   );
      // } catch (e) {
      //   result = await axios.post(
      //     `${config.backend}/learningpath/publish/${learningpath?.id}`,
      //     {}
      //   );
      // }
      // newLearningPath = await saveShare(
      //   create
      //     ? {
      //         lpgroupId: result?.data?.id,
      //       }
      //     : undefined
      // );
      newLearningPath = await saveShare();
    } else {
      newLearningPath = await saveShare();
    }

    const lpgroupId = newLearningPath?.id
      ? newLearningPath.id
      : newLearningPath?.lpgroupId;

    await saveUser(lpgroupId);
    const promises = [];
    promises.push(
      saveUser(
        newLearningPath?.id ? newLearningPath.id : newLearningPath?.lpgroupId
      )
    );

    promises.push(
      saveEvaluator(
        newLearningPath?.id ? newLearningPath.id : newLearningPath?.lpgroupId,
        newLearningPath
      )
    );

    const newCourseInfo = await saveComm(newLearningPath, lpInfo);

    promises.push(saveHome(newLearningPath, lpInfo));

    if (create) {
      promises.push(
        axios.post(`${config.backend}/memberlpgroups`, {
          lpgroupId: newLearningPath.id,
          organisationId: authUser?.activeOrganisationId,
        })
      );
    }

    await Promise.allSettled(promises);

    if (importProgress) {
      await axios.post(`${config.teodoc}/api/lp/importprogress`, {
        lpgroupId,
        userId: student?.userId || student?.id,
      });
    }

    onSubmit && onSubmit(newLearningPath);
  };

  const saveHome = async (myLpgroup = learningpath, myLPInfo = lpInfo) => {
    const changes: any = {};

    if (picture !== myLPInfo?.picture) {
      changes.picture = picture;
    }
    if (abstract !== myLPInfo?.abstract) {
      changes.abstract = abstract;
    }
    if (subTitles !== myLPInfo?.subTitles) {
      changes.subTitles = subTitles;
    }
    if (subImages !== myLPInfo?.subImages) {
      changes.subImages = subImages;
    }
    if (subTexts !== myLPInfo?.subTexts) {
      changes.subTexts = subTexts;
    }
    const axiosFn = myLPInfo.id
      ? axios.put.bind(null, `${config.backend}/lpinfo/${lpInfo.lpgroupId}`)
      : axios.post.bind(null, `${config.backend}/lpinfos`);

    const result: any = await axiosFn({
      lpgroupId: myLpgroup?.id,
      ...changes,
    });

    return result?.data;
  };

  const saveShare = async (newLearningPath = learningpath) => {
    const changes: any = {};

    if (emailCertificate !== learningpath?.emailCertificate) {
      changes.emailCertificate = emailCertificate;
    }
    if (lpgroupAccess !== learningpath?.lpgroupAccess) {
      changes.lpgroupAccess = lpgroupAccess;
    }
    if (lpEndDate !== learningpath?.lpEndDate) {
      changes.lpEndDate = lpEndDate;
    }
    if (isMandatory !== learningpath?.isMandatory) {
      changes.isMandatory = isMandatory;
    }
    if (lpStartDate !== learningpath?.lpStartDate) {
      changes.lpStartDate = lpStartDate;
    }
    if (lpgroupName !== learningpath?.lpgroupName) {
      changes.lpgroupName = lpgroupName;
    }
    if (lpgroupDescription !== learningpath?.lpgroupDescription) {
      changes.lpgroupDescription = lpgroupDescription;
    }
    if (picture !== learningpath?.lpgroupPicture) {
      changes.lpgroupPicture = picture;
    }

    if (specifyItem !== learningpath?.specifyEvaluators) {
      changes.specifyEvaluators = specifyItem;
    }

    const axiosFn = !create
      ? axios.put.bind(null, `${config.backend}/lpgroup/${newLearningPath.id}`)
      : axios.post.bind(null, `${config.backend}/lpgroups`);

    const result: any = await axiosFn({
      masterId: learningpath?.id,
      // learningpathId: newLearningPath?.id
      //   ? newLearningPath.learningpathId
      //   : newLearningPath?.lpgroupId,
      ...changes,
    });

    newLearningPath = result?.data;

    return result?.data;
  };

  const saveComm = async (myLpgroup = learningpath, myLPInfo = lpInfo) => {
    const changes: any = {};

    if (lvCompletePassed !== lpInfo?.lvCompletePassed) {
      changes.lvCompletePassed = lvCompletePassed;
    }
    if (lvCompleteFailed !== lpInfo?.lvCompleteFailed) {
      changes.lvCompleteFailed = lvCompleteFailed;
    }
    if (lvCustomMail !== lpInfo?.lvCustomMail) {
      changes.lvCustomMail = lvCustomMail;
    }
    if (onboardingSteps !== lpInfo?.onboardingSteps) {
      changes.onboardingSteps = onboardingSteps;
    }
    if (nrOfReminders !== lpInfo?.nrOfReminders) {
      changes.nrOfReminders = nrOfReminders;
    }
    if (reminderInterval !== lpInfo?.reminderInterval) {
      changes.reminderInterval = reminderInterval;
    }
    if (doNotRemindProgress / 100 !== lpInfo?.doNotRemindProgress) {
      changes.doNotRemindProgress = doNotRemindProgress / 100;
    }
    if (reminderEmail !== lpInfo?.reminderEmail) {
      changes.reminderEmail = reminderEmail;
    }
    if (welcomeMessage !== lpInfo?.welcomeMessage) {
      changes.welcomeMessage = welcomeMessage;
    }

    const axiosFn = myLPInfo?.id
      ? axios.put.bind(null, `${config.backend}/lpinfo/${lpInfo.lpgroupId}`)
      : axios.post.bind(null, `${config.backend}/lpinfos`);

    const result: any = await axiosFn({
      lpgroupId: myLpgroup?.id,
      ...changes,
    });

    return result?.data;
  };

  const handleSeveTeachers = async (
    lpID: any,
    promisescontent: any,
    teachers: any
  ) => {
    const result = await axios.get(
      `${config.backend}/learningpathnodedetails?learningpathId=${lpID}&organisationId=${authUser?.activeOrganisationId}`
    );
    const dataTree = result?.data;
    for (const node of dataTree) {
      if (specifyItem) {
        if (evaluatorsStep) {
          const newTeachers = create
            ? contentTeachers?.find((el) => el?.baseNodeId === node?.baseNodeId)
                ?.teachers
            : contentTeachers?.find((el) => el?.id === node?.objectId)
                ?.teachers;
          if (node?.type === 'course') {
            const data = await axios.get(
              `${config.backend}/teachers?courseId=${node?.objectId}`
            );
            const nodeTeachers = data?.data;

            const prevTcIds = new Set(nodeTeachers.map((t: any) => t.userId));
            const currentTcIds = new Set(newTeachers.map((t: any) => t.userId));
            for (const teacher of newTeachers) {
              if (!prevTcIds.has(teacher.userId)) {
                promisescontent.push(
                  axios.post(`${config.backend}/teaches`, {
                    courseId: node?.objectId,
                    userId: teacher?.userId,
                  })
                );
              }
            }
            for (const oldTeacher of nodeTeachers) {
              if (!currentTcIds.has(oldTeacher.userId)) {
                promisescontent.push(
                  axios.delete(
                    `${config.backend}/teach/${node?.objectId}/${oldTeacher?.userId}/`
                  )
                );
              }
            }
          }
          if (node?.type === 'training') {
            const data = await axios.get(
              `${config.backend}/trainingteachers?trainingId=${node?.objectId}`
            );
            const nodeTeachers = data?.data;

            const prevTcIds = new Set(nodeTeachers.map((t: any) => t.userId));
            const currentTcIds = new Set(newTeachers.map((t: any) => t.userId));
            for (const teacher of newTeachers) {
              if (!prevTcIds.has(teacher.userId)) {
                promisescontent.push(
                  axios.post(`${config.backend}/trainingteaches`, {
                    trainingId: node?.objectId,
                    userId: teacher?.userId,
                  })
                );
              }
            }
            for (const oldTeacher of nodeTeachers) {
              if (!currentTcIds.has(oldTeacher.userId)) {
                promisescontent.push(
                  axios.delete(
                    `${config.backend}/trainingteach/${node?.objectId}/${oldTeacher?.userId}/`
                  )
                );
              }
            }
          }
        }
      } else {
        if (node?.type === 'course') {
          const data = await axios.get(
            `${config.backend}/teachers?courseId=${node?.objectId}`
          );
          const nodeTeachers = data?.data;

          const prevTcIds = new Set(nodeTeachers.map((t: any) => t.userId));
          const currentTcIds = new Set(teachers.map((t: any) => t.userId));
          for (const teacher of teachers) {
            if (!prevTcIds.has(teacher.userId)) {
              promisescontent.push(
                axios.post(`${config.backend}/teaches`, {
                  courseId: node?.objectId,
                  userId: teacher?.userId,
                })
              );
            }
          }
          for (const oldTeacher of nodeTeachers) {
            if (!currentTcIds.has(oldTeacher.userId)) {
              promisescontent.push(
                axios.delete(
                  `${config.backend}/teach/${node?.objectId}/${oldTeacher?.userId}/`
                )
              );
            }
          }
        }
        if (node?.type === 'training') {
          const data = await axios.get(
            `${config.backend}/trainingteachers?trainingId=${node?.objectId}`
          );
          const nodeTeachers = data?.data;

          const prevTcIds = new Set(nodeTeachers.map((t: any) => t.userId));
          const currentTcIds = new Set(teachers.map((t: any) => t.userId));
          for (const teacher of teachers) {
            if (!prevTcIds.has(teacher.userId)) {
              promisescontent.push(
                axios.post(`${config.backend}/trainingteaches`, {
                  trainingId: node?.objectId,
                  userId: teacher?.userId,
                })
              );
            }
          }
          for (const oldTeacher of nodeTeachers) {
            if (!currentTcIds.has(oldTeacher.userId)) {
              promisescontent.push(
                axios.delete(
                  `${config.backend}/trainingteach/${node?.objectId}/${oldTeacher?.userId}/`
                )
              );
            }
          }
        }
      }

      if (node?.type === 'learningpath') {
        await handleSeveTeachers(node?.objectId, promisescontent, teachers);
      }
    }
  };

  const saveEvaluator = async (
    myLearningpathId = learningpath?.id,
    newLearningPath: any
  ) => {
    const provisionTeachersResults = newTeachers.map(async (item: any) => {
      return new Promise((resolve, reject) => {
        if (item.newUser) {
          axios
            .post(`${config.backend}/invite?lang=${authUser?.lang}`, {
              organisationId: authUser?.activeOrganisationId,
              email: item.label,
              firstName: item.firstName,
              lastName: item.lastName,
              phone: item.phone,
              role: Math.min(item.role, 50),
            })
            .then((result) => {
              resolve(
                Object.assign({}, result?.data, {
                  key: result?.data.id,
                  role: item.role,
                })
              );
            })
            .catch(reject);
        } else {
          resolve(item);
        }
      });
    });

    const teachers: any[] = await Promise.all(provisionTeachersResults);

    const promiseTeacherMembers: any[] = [];
    const prevIds = new Set(prevTeachers.map((t) => t.userId));
    const currentIds = new Set(teachers.map((t) => t.userId));
    for (const teacher of teachers) {
      if (!prevIds.has(teacher.id)) {
        promiseTeacherMembers.push(
          new Promise((resolve) => {
            axios
              .post(`${config.backend}/members`, {
                organisationId: authUser?.activeOrganisationId,
                userId: teacher?.userId || teacher?.id,
              })
              .finally(() => resolve(teacher));
          })
        );
      }
    }
    await Promise.all(promiseTeacherMembers);

    const promisesFinal: any[] = [];

    for (const teacher of teachers) {
      if (!prevIds.has(teacher.id)) {
        promisesFinal.push(
          axios.post(`${config.backend}/lpteaches`, {
            lpgroupId: myLearningpathId,
            userId: teacher?.userId || teacher?.id,
            role: teacher?.lprole || 20,
          })
        );
      }
    }
    for (const oldTeacher of prevTeachers) {
      if (!currentIds.has(oldTeacher.id)) {
        promisesFinal.push(
          axios.delete(
            `${config.backend}/lpteach/${learningpath?.id}/${oldTeacher?.userId}/`
          )
        );
      }
    }

    const promisescontent: any[] = [];

    await handleSeveTeachers(
      newLearningPath?.learningpathId,
      promisescontent,
      teachers
    );

    return Promise.allSettled([...promisesFinal, ...promisescontent]);
  };

  const saveUser = async (myLearningpathId = learningpath?.id) => {
    const promises = [];

    // delete the users
    for (const usr of delUsers) {
      await axios.delete(
        `${config.backend}/lpfollow/${myLearningpathId}/${
          usr?.studentId || usr?.userId
        }/`
      );
    }

    // delete the teams
    for (const team of delTeams) {
      axios.delete(`${config.backend}/lpteam/${myLearningpathId}/${team?.id}/`);
    }

    //save the teams
    promises.push(
      newTeams.map((team: any) =>
        axios.post(`${config.backend}/lpteams`, {
          lpgroupId: myLearningpathId,
          teamId: team?.teamId || team?.id,
        })
      )
    );

    // save settings
    if (hasCustomLanding) {
      promises.push(
        axios.put(`${config.backend}/lpgroup/${myLearningpathId}`, {
          hasCustomLanding,
        })
      );
    } else {
      promises.push(
        axios.put(`${config.backend}/lpgroup/${myLearningpathId}`, {
          hasCustomLanding,
          lpgroupDescription: learningpath?.lpDescription,
          lpgroupName: learningpath?.lpName,
        })
      );
    }

    //save the users
    const provisionResults = newUsers.map(async (item: any) => {
      return new Promise((resolve, reject) => {
        if (item.newUser) {
          axios
            .post(`${config.backend}/invite/provision?lang=${authUser?.lang}`, {
              organisationId: authUser?.activeOrganisationId,
              email: item.label,
              firstName: item.firstName,
              lastName: item.lastName,
              phone: item.phone,
              role: Math.min(item.role, 50),
            })
            .then((result) => {
              resolve(
                Object.assign({}, result?.data, {
                  key: result?.data.id,
                  role: item.role,
                })
              );
            })
            .catch(reject);
        } else {
          resolve(item);
        }
      });
    });

    const students: any[] = await Promise.all(provisionResults);

    const promiseStudentMembers: any[] = [];
    for (const student of students) {
      promiseStudentMembers.push(
        new Promise((resolve) => {
          axios
            .post(`${config.backend}/members`, {
              organisationId: authUser?.activeOrganisationId,
              userId: student?.userId || student?.id,
            })
            .finally(() => resolve(student));
        })
      );
    }

    await Promise.all(promiseStudentMembers);

    const promisesFinal: any[] = [];
    for (const student of students) {
      promisesFinal.push(
        axios.post(`${config.backend}/lpfollows`, {
          lpgroupId: myLearningpathId,
          userId: student?.userId || student?.id,
        })
      );
    }

    return Promise.allSettled([...promises, ...promisesFinal]);
  };

  return (
    <div className="relative h-full max-h-[calc(100vh_-_96px)] border-t border-grey-02">
      <Stepper>
        <Stepper.Item
          isActive={step === 1}
          isDone={step > 1}
          onClick={() => {
            setStep(1);
            step !== 1 && !loadedStep[0] && setLoadStep(true);
          }}
          step="1"
        >
          {!isMobile && <>{t('pages.course_content_flow.users_teams')}</>}
        </Stepper.Item>
        <Stepper.Item
          isActive={step === 2}
          isDone={step > 2}
          onClick={() => {
            setStep(2);
            step !== 2 && !loadedStep[1] && setLoadStep(true);
          }}
          step="2"
        >
          {!isMobile && <>{t('pages.course_content_flow.homepage')}</>}
        </Stepper.Item>
        <Stepper.Item
          isActive={step === 3}
          isDone={step > 3}
          onClick={() => {
            setStep(3);
            step !== 3 && !loadedStep[2] && setLoadStep(true);
          }}
          step="3"
        >
          {!isMobile && <>{t('pages.course_content_flow.sharing_settings')}</>}
        </Stepper.Item>
        <Stepper.Item
          isActive={step === 4}
          isDone={step > 4}
          onClick={() => {
            setStep(4);
            step !== 4 && !loadedStep[3] && setLoadStep(true);
          }}
          step="4"
        >
          {!isMobile && <>{t('pages.course_content_flow.evaluators')}</>}
        </Stepper.Item>
        <Stepper.Item
          isActive={step === 5}
          isDone={step > 5}
          onClick={() => {
            setStep(5);
            step !== 5 && !loadedStep[4] && setLoadStep(true);
          }}
          step="5"
        >
          {!isMobile && <>{t('pages.course_content_flow.communication')}</>}
        </Stepper.Item>
      </Stepper>

      <div className="relative h-full max-h-[calc(100vh_-_256px)] overflow-y-auto py-8">
        {loadStep && (
          <div className="fixed absolute inset-0 z-[13] z-10 flex bg-white/75">
            <div className="m-auto">
              <TEOLoader
                loaderSrc="/images/TEOloader.gif"
                className="w-[110px]"
              />
            </div>
          </div>
        )}
        <div className="mx-auto flex max-w-screen-md flex-col justify-center px-3">
          <div className="relative flex flex-col justify-center">
            {step === 1 && (
              // <AddUserTeamStep
              //   state={userState}
              //   teamInfo={teamInfo}
              //   student={student}
              //   setLoadStep={setLoadStep}
              // />
              <AddFollowersStep
                state={userState}
                teamInfo={teamInfo}
                student={student}
                setLoadStep={setLoadStep}
                courseType={'learning-path'}
                currentUsers={currentUsers}
                setCurrentUsers={setCurrentUsers}
                currentTeams={currentTeams}
                setCurrentTeams={setCurrentTeams}
                setDelUsers={setDelUsers}
                setDelTeams={setDelTeams}
                loadedStep={() => {
                  const newLoader = loadedStep?.map((el, i) =>
                    i === 0 ? true : el
                  );
                  setLoadedStep(newLoader);
                }}
              />
            )}
            {step === 2 && (
              <HomePageStep
                state={homepageState}
                setLoadStep={setLoadStep}
                loadedStep={() => {
                  const newLoader = loadedStep?.map((el, i) =>
                    i === 1 ? true : el
                  );
                  setLoadedStep(newLoader);
                }}
              />
            )}
            {step === 3 && (
              <SharingSettingsStep
                state={shareState}
                setLoadStep={setLoadStep}
                loadedStep={() => {
                  const newLoader = loadedStep?.map((el, i) =>
                    i === 2 ? true : el
                  );
                  setLoadedStep(newLoader);
                }}
              />
            )}
            {step === 4 && (
              <EvaluatorsStep
                state={evaluatorsState}
                setLoadStep={setLoadStep}
                learningpath={learningpath}
                treeConrent={treeConrent}
                create={create}
                loadedStep={() => {
                  const newLoader = loadedStep?.map((el, i) =>
                    i === 3 ? true : el
                  );
                  setLoadedStep(newLoader);
                }}
              />
            )}
            {step === 5 && (
              <CommunicationStep
                state={commState}
                loadeFroala={loadeFroala}
                setLoadStep={setLoadStep}
                loadedStep={() => {
                  const newLoader = loadedStep?.map((el, i) =>
                    i === 4 ? true : el
                  );
                  setLoadedStep(newLoader);
                }}
              />
            )}
          </div>
        </div>
      </div>

      <div className="mt-auto flex border-t border-grey-02 py-5">
        <div className="mx-auto flex w-full max-w-screen-md justify-end px-3">
          <Button
            variant="outline"
            disabled={step === 1}
            onClick={() => {
              setStep(step - 1);
              setLoadStep(true);
            }}
            className="mr-auto"
            data-testid="prevBtn"
          >
            {t('button.previous')}
          </Button>
          <Button
            className="mr-2"
            variant={!create ? 'outline' : undefined}
            disabled={step === 5}
            onClick={() => {
              setStep(step + 1);
              setLoadStep(true);
            }}
            data-testid="nextBtn"
          >
            {t('button.next')}
          </Button>
          {(!create || step === 5) && (
            <Button
              onClick={() => {
                document.body.style.overflow = 'unset';
                handleSave();
              }}
              data-testid="nextBtn"
            >
              {t('button.save')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default StepsComponentLP;
